import { create } from 'zustand';
import { companyClient } from 'shared/domain/company/companyClient';
import { contractClient } from 'shared/domain/contract/contractClient';
import { EntityName } from 'shared/domain/entityName';
import { issueFormClient } from 'shared/domain/issueForm/issueFormClient';
import { levelClient } from 'shared/domain/level/levelClient';
import type { FieldSkeleton } from 'shared/types/form';
import { createSelectors, StoreName, withDevtools } from '../config';
import { createEntityCollectionActions } from '../entityCollection';
import { createDataActions, createInitialData } from '../types';
import type { IssueFormStore } from './types';

const useIssueFormStoreBase = create<IssueFormStore>()(
  withDevtools(
    (set, get) => ({
      data: createInitialData<FieldSkeleton>(),

      actions: {
        ...createDataActions<FieldSkeleton, IssueFormStore>(set),
        ...createEntityCollectionActions(
          {
            client: issueFormClient,
            entityName: EntityName.issueForm,
            // Companies, contracts and levels are options of the form's fields.
            reloadOnChangesOf: [companyClient, contractClient, levelClient],
          },
          () => get().actions
        ),
      },
    }),
    StoreName.IssueForm
  )
);

export const useIssueFormStore = createSelectors(useIssueFormStoreBase);

export const getIssueFormStoreState = (): IssueFormStore => useIssueFormStore.getState();
